import i18n, { type Resource } from 'i18next'
// @ts-ignore
import Polyglot from 'i18next-polyglot'
import { initReactI18next } from 'react-i18next'

import LanguageDetector from '../services/LanguageDetector'

interface Process {
  env: {
    NODE_ENV: string
  }
}

// eslint-disable-next-line no-var
declare var process: Process

type AppResources = {
  cs: unknown
  en?: unknown
}

export const getI18nConfig = (resource?: AppResources) => {
  const resources: Resource = {
    cs: {
      translation: resource?.cs ?? {}
    },
    en: {
      translation: resource?.en ?? {}
    }
  }

  i18n
    // pass the i18n instance to react-i18next.
    .use(initReactI18next)
    .use(Polyglot)
    // init i18next
    // for all options read: https://www.i18next.com/overview/configuration-options
    .init({
      debug: process.env.NODE_ENV === 'development',
      fallbackLng: 'en',
      lng: LanguageDetector(),
      resources,

      detection: {
        order: ['htmlTag']
      },

      interpolation: {
        escapeValue: false // not needed for react as it escapes by default
      }
    })

  return i18n
}
